import { listOfSubscriptions } from "../../../common/envConfig";

/**
 * Product type options for cohort analysis
 */
export const PRODUCT_TYPE_OPTIONS = [
  { value: listOfSubscriptions.PREMIUM, label: "3D Pro" },
  { value: listOfSubscriptions.STUDENT_LITE, label: "3D Player" },
  { value: listOfSubscriptions.STUDIO_MASTER, label: "3D Studio" },
];

/**
 * Subscription type options for cohort analysis
 */
export const SUBSCRIPTION_TYPE_OPTIONS = [
  { value: "monthly", label: "Monthly" },
  { value: "annually", label: "Annually" },
  { value: "all", label: "All" },
];

